<template>
  <div>

    <p>
      club chat copies
    </p>

 </div>
</template>

<script>
export default {
  name: 'ClubChatCopies',

  props: {
    clubId: {
      type: Number,
      required: true,
    }
  },
};
</script>
